module.exports = __webpack_public_path__ + "img/i_list_reply.383617ce.svg";